/**
 * Motion 组件 Widget 类（6.2 BaseWidget 体系）
 * MotionGroup / AnimatedRoute / ScrollReveal
 *
 * 说明：动效引擎由并行任务实现；本组件渲染器自包含 CSS transition/animation
 * 兜底（接口约定：渲染器消费 motionPreset 等动效属性，后续可无缝替换为引擎）。
 */
import type { PropertyPaneConfig } from "@shared/types";

import { getMaterial } from "../materials";
import { BaseWidget } from "./base-widget";
import { buildMaterialPropertyPaneConfig } from "./property-pane";

function paneConfigFor(type: string, extraSections: PropertyPaneConfig[] = []): PropertyPaneConfig[] {
  return buildMaterialPropertyPaneConfig(getMaterial(type)?.propSchema ?? [], extraSections);
}

export class MotionGroupWidget extends BaseWidget {
  getWidgetType(): string {
    return "MotionGroup";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("MotionGroup");
  }
}

export class AnimatedRouteWidget extends BaseWidget {
  getWidgetType(): string {
    return "AnimatedRoute";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("AnimatedRoute");
  }
}

export class ScrollRevealWidget extends BaseWidget {
  getWidgetType(): string {
    return "ScrollReveal";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("ScrollReveal");
  }
}
